/** Origens de cancelamento dos pedidos */
export interface PedidoOrigemCancelamento {
    id: number;
    nome: string;
}

export const pedidoOrigemCancelamentoSogivendas: PedidoOrigemCancelamento = {id: 1, nome: 'Sogivendas'};
export const pedidoOrigemCancelamentoERP: PedidoOrigemCancelamento = {id: 2, nome: 'ERP'};
export const pedidoOrigemCancelamentoEcommerce: PedidoOrigemCancelamento = {id: 3, nome: 'E-Commerce'};


export const pedidoOrigensCancelamentos: PedidoOrigemCancelamento[] = [
    pedidoOrigemCancelamentoSogivendas,
    pedidoOrigemCancelamentoERP,
    pedidoOrigemCancelamentoEcommerce
];

/** Verifica se a origem do lançamento do pedido é o Sogivendas */
export function isPedidoOrigemCancelamentoSogivendas(origemCancelamento: number): boolean {
    return origemCancelamento === pedidoOrigemCancelamentoSogivendas.id;
}

/** Verifica se a origem do lançamento do pedido é o ERP */
export function isPedidoOrigemCancelamentoERP(origemCancelamento: number): boolean {
    return origemCancelamento === pedidoOrigemCancelamentoERP.id;
}

/** Verifica se a origem do lançamento do pedido é o E-commerce */
export function isPedidoOrigemCancelamentoEcommerce(origemCancelamento: number): boolean {
    return origemCancelamento === pedidoOrigemCancelamentoEcommerce.id;
}
